export * from './CopilotMessageFooter';
export * from './CopilotMessageFooter.types';
export * from './renderCopilotMessageFooter';
export * from './useCopilotMessageFooter';
export * from './useCopilotMessageFooterStyles';
//# sourceMappingURL=index.js.map